export default __webpack_public_path__ + "static/media/codeforces-sponsored-by-ton.e6dbb67c.png";